import { render } from "./StatsFunnel.vue?vue&type=template&id=6a3bb45a"
import script from "./StatsFunnel.vue?vue&type=script&lang=js"
export * from "./StatsFunnel.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/Vakifbank-Vue-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__